module.exports = __webpack_public_path__ + "img/main-01-12.45cc3426.png";